<template>
  <div>
    <!-- 榜单卡片的表单 -->
    <el-form class="listForm" :model="listForm" :rules="rules" ref="listForm" label-width="160px">
      <el-form-item label="卡片名称" prop="name">
        <el-input maxlength="99" size="small" v-model="listForm.name" placeholder="请输入卡片名称" clearable></el-input>
      </el-form-item>
      <el-form-item label="卡片标题" prop="title">
        <el-input maxlength="99" size="small" v-model="listForm.title" placeholder="请输入卡片标题" clearable></el-input>
      </el-form-item>
      <el-form-item label="卡片描述" prop="description">
        <el-input maxlength="99" size="small" v-model="listForm.description" placeholder="请输入卡片描述" clearable></el-input>
      </el-form-item>
      <!-- 频道选择 -->
      <el-form-item label="频道" prop="channelItems">
        <el-button size="small" @click="showChannelDialog">添加频道</el-button>
        <!-- 频道列表 -->
        <avue-crud v-if="listForm.channelItems && listForm.channelItems.length" style="width: 100%" :option="option"
          :data="listForm.channelItems" ref="crud">
          <!-- 自定义搜索框 -->
          <template slot="mySearch"> </template>
          <!-- 自定义表格列 -->
          <template #coverImg="{ row }">
            <el-image v-if="row.coverImg" style="width: 100px; height: 100px" :src="row.coverImg"
              fit="scale-down"></el-image>
            <span v-else>暂无图片</span>
          </template>
          <template #medias="{ row }">
            <span>{{ row.contentList.length || '' }}</span>
          </template>
          <!-- 自定义操作栏 -->
          <template #menu="{ row }">
            <el-button 
              type="text" 
              size="small" 
              :disabled="!canMoveUp(listForm.channelItems, row)" 
              @click="moveUp(row)"
            >
              上移
            </el-button>
            <el-button 
              type="text" 
              size="small" 
              :disabled="!canMoveDown(listForm.channelItems, row)" 
              @click="moveDown(row)"
            >
              下移
            </el-button>
            <el-button 
              type="text" 
              size="small" 
              :disabled="!canMoveTop(listForm.channelItems, row)" 
              @click="moveTop(row)"
            >
              置顶
            </el-button>
            <el-button type="text" size="small" @click="editChannel(row)">编辑</el-button>
            <el-button type="text" size="small" style="color: #f56c6c;" @click="delChannel(row)">删除</el-button>
          </template>
        </avue-crud>
      </el-form-item>


      <el-form-item label="备注" prop="remark">
        <el-input show-word-limit maxlength="9999" type="textarea" size="small" v-model="listForm.remark"
          placeholder="请输入备注" clearable></el-input>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-radio-group v-model="listForm.status">
          <el-radio :label="1">生效</el-radio>
          <el-radio :label="0">失效</el-radio>
        </el-radio-group>
      </el-form-item>
      <!-- 生效模式 -->
      <el-form-item v-if="listForm.status === 1" label="选择" prop="effectMode">
        <!-- 立即生效 1  指定时间生效 2 -->
        <el-radio-group v-model="listForm.effectMode">
          <el-radio :label="1">立即生效</el-radio>
          <el-radio :label="2">指定时间生效</el-radio>
        </el-radio-group>
      </el-form-item>
      <!-- 生效时间 -->
      <el-form-item v-if="listForm.status === 1 && listForm.effectMode === 2" label="生效时间" prop="effectTime">
        <el-date-picker size="small" :picker-options="{
          disabledDate(time) {
            return time.getTime() < Date.now() - 8.64e7;
          },
        }" v-model="listForm.effectTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange" range-separator="至"
          start-placeholder="生效开始时间" end-placeholder="生效结束时间" clearable>
        </el-date-picker>
      </el-form-item>
    </el-form>
    <!-- 保存和取消按钮 -->
    <div class="btn-container" style="text-align: right; margin-top: 20px">
      <el-button size="small" type="primary" @click="saveCard">保存</el-button>
      <el-button size="small" @click="cancel">取消</el-button>
    </div>
    <ChannelSelect ref="channelSelect" @save="getChannel"></ChannelSelect>
  </div>
</template>

<script>
import ChannelSelect from './channelSelect.vue'
import { deleteChannel, addAppCard, updateAppCard } from "@/api/apps/appCard"
import { formatAddListForm } from "../utils/helper"
// eslint-disable-next-line no-unused-vars
import { moveUp, moveDown, moveTop, canMoveUp, canMoveDown, canMoveTop } from "../utils/sortUtils"
import Message from '@/components/Message'
export default {
  name: 'WebSaaSListForm',
  components: {
    ChannelSelect
  },
  inject: ["optionType"],
  data() {
    return {

      option: {
        lazy: true,
        tip: false,
        simplePage: true,
        searchShow: false,
        // searchMenuSpan: 6,
        tree: true,
        border: true,
        /** 表格索引 */
        index: false,
        /** 索引说明 */
        indexLabel: "No",
        /** 表格搜索显隐按钮 */
        searchShowBtn: false,
        /** 是否启用功能按钮 */
        searchIcon: false,
        searchIndex: 0,
        /** 表格查看按钮 */
        viewBtn: false,
        /** 表格新增按钮 */
        addBtn: false,
        /** 表格删除按钮 */
        delBtn: false,
        /** 表格修改按钮 */
        editBtn: false,
        /** 表格搜索按钮 */
        searchBtn: false,
        /** 表格清空按钮 */
        emptyBtn: false,
        /** 表格列操作按钮 */
        columnBtn: false,
        /** 表格刷新数据按钮 */
        refreshBtn: false,
        /** 开启拖拽功能 */
        sortable: true,
        // dragHandler: true,
        rowSort: true,
        columnSort: true,
        menu: true,
        menuWidth: 120,
        // menuFixed: true,
        column: [
          {
            label: "ID",
            prop: "id",
            width: 40,
          },
          {
            label: "频道名称",
            prop: "name",
            overHidden: true,
          },
          {
            label: "图片",
            prop: "coverImg",
            slot: true,
            width: 140,
          },
          {
            label: "列表内容",
            prop: "medias",
            slot: true
          },
          {
            label: "",
            prop: "my",
            hide: true,
            showColumn: false,
            search: true,
            display: false,
            menuClassName: "myClass",
            searchslot: true,
          },
        ],
      },
      listForm: {
        /** 卡片名称 */
        name: "",
        /** 卡片标题 */
        title: "",
        /** 卡片描述 */
        description: "",
        /** 频道ID */
        channelItems: [],
        /** 备注 */
        remark: '',
        /** 卡片类型（1：焦点卡片；2：专题卡片；3：导航卡片；4：榜单卡片） */
        type: 4,
        /** 状态（1：生效；0：失效 2；待生效） */
        status: "",
        /** 生效模式 1：立即生效；2：指定时间生效 */
        effectMode: "",
        /** 生效时间 */
        effectTime: [],
      },
      rules: {
        /** 卡片名称 */
        name: [
          { required: true, message: '请输入卡片名称', trigger: 'blur' },
          { max: 99, message: '长度不能超过99个字符', trigger: 'blur' },
        ],
        /** 卡片标题 */
        title: [
          { required: true, message: '请输入卡片标题', trigger: 'blur' },
          { max: 99, message: '长度不能超过99个字符', trigger: 'blur' },
        ],
        /** 卡片描述 */
        description: [
          { required: true, message: '请输入卡片描述', trigger: 'blur' },
          { max: 99, message: '长度不能超过99个字符', trigger: 'blur' },
        ],
        /** 频道 */
        channelItems: [
          { required: true, message: '请选择频道', trigger: 'blur' },
        ],
        /** 备注 */
        remark: [
          { max: 9999, message: '长度不能超过9999个字符', trigger: 'blur' },
        ],
        status: [{ required: true, message: "请选择状态", trigger: "blur" }],
        effectMode: [
          { required: true, message: "请选择生效模式", trigger: "blur" },
        ],
        effectTime: [
          {
            required: true,
            validator: (rule, value, callback) => {
              console.log("生效时间", value);
              if (value === undefined || value.length === 0) {
                callback(new Error("请选择生效时间"));
              } else {
                // 校验开始时间，大于当前时间
                if (value[0]) {
                  // 将字符串格式的开始时间转换为Date对象
                  const startTime = new Date(value[0]);

                  // 检查转换是否成功，且开始时间是否大于当前时间
                  if (
                    isNaN(startTime.getTime()) ||
                    startTime.getTime() < Date.now()
                  ) {
                    callback(new Error("生效开始时间不能小于当前时间"));
                  }
                }
                if (value[1]) {
                  // 将字符串格式的结束时间转换为Date对象
                  const endTime = new Date(value[1]);

                  // 检查转换是否成功，且结束时间是否大于开始时间
                  if (
                    isNaN(endTime.getTime()) ||
                    endTime.getTime() < new Date(value[0]).getTime()
                  ) {
                    callback(new Error("生效结束时间不能小于开始时间"));
                  }
                }
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },
    };
  },



  methods: {
    /** 接收频道数据 */
    getChannel(data) {

      console.log('接收频道数据', data);
      /** 根据id先判断是push 还是替换 */
      const index = this.listForm.channelItems.findIndex((item) => item.id === data.id);
      if (index !== -1) {
        this.listForm.channelItems.splice(index, 1, data);
      } else {
        this.listForm.channelItems.push(data);
      }

    },
    /** 选择频道 */
    showChannelDialog() {
      this.$refs.channelSelect.show();
    },
    /** 编辑频道 */
    editChannel(row) {
      console.log('编辑频道', row);
      this.$refs.channelSelect.show(row, 'edit');
    },
    /** 删除频道 */
    delChannel(row) {
      console.log('删除频道', row);
      this.$confirm('是否删除该频道?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data } = await deleteChannel([row.id]);
        console.log('删除频道的响应', data);
        if (data.code === 200) {
          Message.success("删除成功")
          this.listForm.channelItems = this.listForm.channelItems.filter(item => item.id !== row.id);
        }
      }).catch(() => {
        console.log('catch删除');
      });
    },
    /** 保存 */
    saveCard() {
      this.$refs.listForm.validate((valid) => {
        console.log('榜单卡片数据', this.listForm);
        if (valid) {
          console.log('榜单卡片验证通过');
          if (this.optionType.value === 'add') {
            this.add();
          } else {
            this.edit();
          }
        }
      });
    },
    /** 新增 */
    async add() {
      console.log('新增榜单卡片');
      console.log('榜单卡片数据', this.listForm);
      const params = formatAddListForm(this.listForm);
      console.log('新增榜单卡片的参数', params);
      const { data } = await addAppCard(params)
      console.log('新增榜单卡片的响应', data);
      if (data.code === 200) {
        Message.success("新增榜单卡片成功");
        this.$emit("reload");
        this.$emit("close");
      }
    },
    /** 编辑 */
    async edit() {
      console.log('编辑榜单卡片');
      console.log('榜单卡片数据', this.listForm);
      const params = formatAddListForm(this.listForm);
      console.log('编辑榜单卡片的参数', params);
      const { data } = await updateAppCard(params)
      console.log('编辑榜单卡片的响应', data);
      if (data.code === 200) {
        Message.success("编辑榜单卡片成功");
        this.$emit("reload");
        this.$emit("close");
      }
    },
    /** 重置表单值 */
    reset() {
      /** 清空表单 */
      this.listForm = {
        /** 卡片名称 */
        name: "",
        /** 卡片标题 */
        title: "",
        /** 卡片描述 */
        description: "",
        /** 频道ID */
        channelItems: [],
        /** 备注 */
        remark: '',
        /** 状态（1：生效；0：失效 2；待生效） */
        status: "",
        /** 生效模式 1：立即生效；2：指定时间生效 */
        effectMode: "",
        type: 4,
        /** 生效时间 */
        effectTime: [],
      };
    },
    /** 取消的事件 */
    cancel() {
      this.$emit("close");
      /** 清空表单验证规则 */
      this.$refs.listForm.clearValidate();
      this.reset();
    },
    /** 上移 */
    moveUp(row) {
      moveUp(this.listForm.channelItems, row);
    },
    /** 下移 */
    moveDown(row) {
      moveDown(this.listForm.channelItems, row);
    },
    /** 置顶 */
    moveTop(row) {
      moveTop(this.listForm.channelItems, row);
    },
    /** 是否可以上移 */
    canMoveUp(items, row) {
      return canMoveUp(items, row);
    },
    /** 是否可以下移 */
    canMoveDown(items, row) {
      return canMoveDown(items, row);
    },
    /** 是否可以置顶 */
    canMoveTop(items, row) {
      return canMoveTop(items, row);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../.././styles/draggable.scss";
</style>